export default {
  $el: 'section',
  attrs: {},
  children: [
    {
      label: 'Is there an unexpected decrease in order rates?',
      $formkit: 'radio',
      if: '$incidentForms.type === Technology',
      name: 'webAppOrdersDecrease',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Is a major feature of the website or app unavailable?',
      $formkit: 'radio',
      help: 'Including any part of the checkout process, transactional emails, video cards.',
      if: '$incidentForms.webAppOrdersDecrease === no',
      name: 'majorFeatureUnavailable',
      type: 'radio',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Is there issue that is negatively impacting multiple people?',
      $formkit: 'radio',
      if: '$incidentForms.majorFeatureUnavailable === no',
      name: 'issueMultiplePeople',
      type: 'radio',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      $el: 'div',
      if: '$incidentForms.issueMultiplePeople === no',
      children: [
        {
          $el: 'section',
          attrs: {
            class: 'incident-details',
          },
          children: [
            {
              $el: 'h3',
              children: 'We believe that this is a bug',
            },
            {
              $el: 'p',
              children: [
                'Please raise a message in the ',
                {
                  $el: 'a',
                  children: '#card-bugs',
                  attrs: {
                    href: 'https://app.slack.com/client/TMVMM4ML5/CSQVA4EJH',
                  },
                },
                ' channel.',
              ],
            },
          ],
        },
      ],
    },
  ],
}
